"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function PushNotifications(_a) {
    var channel = _a.channel, firebase_token = _a.firebase_token, requestFirebaseToken = _a.requestFirebaseToken;
    var _b = ra_fetch_1.useApi('media')
        .store('messages.subscribe', { topic: channel.id }), subscribe = _b[0], setSubscribe = _b[1], submitSubscribe = _b[2];
    var _c = react_1.useState(__assign(__assign({}, ra_fetch_1.Fetcher.model()), { loading: Boolean(firebase_token) })), subscribed = _c[0], setSubscribed = _c[1];
    function onSubscribe() {
        submitSubscribe({ token: firebase_token }).then(function (response) { return setSubscribed(response); });
    }
    function onSubmit() {
        if (!firebase_token) {
            return requestFirebaseToken();
        }
        setSubscribed(__assign(__assign({}, subscribed), { submitting: true }));
        if (subscribed.data.subscribed) {
            return ra_fetch_1.Fetcher.api('media')
                .store('messages.unsubscribe', { topic: channel.id, token: firebase_token })
                .then(function (response) { return setSubscribed(response); });
        }
        onSubscribe();
    }
    react_1.useEffect(function () {
        if (firebase_token) {
            ra_fetch_1.Fetcher.api('media')
                .show('messages.subscribed', { topic: channel.id, token: firebase_token })
                .then(function (response) { return setSubscribed(response); });
        }
    }, []);
    react_1.useEffect(function () {
        if (!subscribed.loading && firebase_token && !subscribed.data.subscribed) {
            setSubscribed(__assign(__assign({}, subscribed), { submitting: true }));
            onSubscribe();
        }
    }, [firebase_token]);
    if (subscribed.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-channels-push-notifications-button' },
        react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onSubmit, type: 'primary', className: 'outline push-button relative tooltip' },
            react_1.default.createElement(storybook_1.Notifications.Tooltip, { position: 'left', text: "Wil jij push notificaties ontvangen bij nieuwe videos en livestreams van " + channel.label }),
            "Push notificaties ontvangen"),
        subscribed.submitting && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader', className: 'storybook-channels-push-notifications-loader' }),
        !subscribed.submitting && react_1.default.createElement(storybook_1.Forms.Toggle, { className: 'storybook-channels-push-notifications-toggle', value: subscribed.data.subscribed }));
}
exports.default = PushNotifications;
